import CSS from 'csstype';
import React, { JSX } from 'react';

import { usePanel } from '~/src/dash/components/layout/contexts';
import { getFontWeight } from '~/src/dash/components/text/common';
import { ITProps, TKey, usePublicaTranslation } from '~/src/dash/publicaUI';

interface ISpanProps {
  muted?: boolean;
  baseColor?: boolean;
  highlighted?: boolean;
  color?: string;
  baseWeight?: boolean;
  bold?: boolean;
  heavy?: boolean;
  italic?: boolean;
  // standard
  onClick?: () => void;
  onHover?: () => void;
  offHover?: () => void;
  hoverColor?: string;
  style?: CSS.Properties;
  className?: string;
  children?: any;
  tKey?: TKey;
  tProps?: ITProps;
}

export const Span = ({
  muted,
  baseColor,
  highlighted,
  color,
  baseWeight,
  bold,
  heavy,
  italic,
  style,
  className = '',
  children,
  onClick,
  tKey,
  tProps,
}: ISpanProps): JSX.Element => {
  const { fontColors } = usePanel();
  const { t } = usePublicaTranslation();
  const getSpanColor = () => {
    if (muted) {
      return fontColors.muted;
    }
    if (baseColor) {
      return fontColors.base;
    }
    if (highlighted) {
      return fontColors.highlighted;
    }
    return color || 'inherit';
  };
  const defaultColor = getSpanColor();
  return (
    <span
      {...(onClick && { onClick })}
      className={className}
      style={{
        color: defaultColor,
        fontWeight: getFontWeight({
          baseWeight,
          bold,
          heavy,
        }),
        fontStyle: italic ? 'italic' : 'inherit',
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
    >
      {tKey ? t(tKey, tProps) : children}
    </span>
  );
};
